import moment from "moment/moment";
import axios from "axios";

function getPictureUrl(pictureObject) {
    const apiUrl = process.env.VUE_APP_API_BASE_URL;

    return `${apiUrl}${pictureObject.url}`;
}

function formatDate(date) {
    return moment(date).format('DD.MM.YYYY');
}

async function getCoordinatesFromAddress(address) {
    try {
        const request = await axios.get(`https://nominatim.openstreetmap.org/search?format=json&q=${address}`);

        if (request.status === 200) return {
            lat: request.data[0].lat,
            lng: request.data[0].lon
        }

        else return undefined;
    } catch {
        return undefined;
    }

}

const monthMap = {
    '1': 'Januar',
    '2': 'Februar',
    '3': 'März',
    '4': 'April',
    '5': 'Mai',
    '6': 'Juni',
    '7': 'Juli',
    '8': 'August',
    '9': 'September',
    '10': 'Oktober',
    '11': 'November',
    '12': 'Dezember',
}

const months = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

 const metricEventTypes = {
     PAGE_VISIT: 'PAGE_VISIT',
     FILE_DOWNLOAD: 'FILE_DOWNLOAD'
 }

const metricParents = {
    NONE: undefined,
    SERVICE_AREA: 'Service Area',
    SERVICE: 'Service',
    SUB_SERVICE: 'Sub Service',
    NEWS: 'News',
    FUNDS: 'Fördermöglichkeiten',
    PRESS: 'Presse',
    EVENTS: 'Veranstaltungen',
    BILDUNGSPORTAL: 'Bildungsportal'
}

function getNoDateElectionPlaceholderText(date) {
     const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString().slice(2);

     return `- Keine öffentlichen Informationen zugänglich (Stand: ${month}/${year})`
}

export { getPictureUrl, formatDate, getCoordinatesFromAddress, monthMap, months, metricEventTypes, metricParents, getNoDateElectionPlaceholderText }